import * as React from "react"
import {Box, Typography} from "@mui/material";
import { formatDate } from "@ui-seeker/utils";

import SkuLabel from "@components/SkuLabel";

export default function ProductDetailsBlock({ sku, category, brand, ean, firstSeen, lastSeen }) {
  return <Box >
        <SkuLabel label={sku} ellipsis={false} sx={{ whiteSpace: "none",}} />
        <Typography variant="caption" sx={{display: "block", color: "text.disabled"}}>
            <Box>
                Category: {category}
            </Box>
        </Typography>
        <Typography variant="caption" sx={{display: 'block', color: "text.disabled", whiteSpace: 'normal', wordBreak: 'break-word'}}>
            Brand: {brand}
        </Typography>
        <Typography variant="caption" sx={{display: 'block', color: "text.disabled"}}>
            EAN: {ean}
        </Typography>
        <Typography variant="caption" sx={{display: 'block', color: "text.disabled"}}>
            First Seen: {formatDate(firstSeen, { isString: true })}
        </Typography>
        <Typography variant="caption" sx={{display: 'block', color: "text.disabled"}}>
            Last Seen: {formatDate(lastSeen, { isString: true })}
        </Typography>
    </Box>
}
